"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const DestinationAttributes_mappers_1 = require("./DestinationAttributes.mappers");
const DestinationRating_1 = __importDefault(require("./DestinationRating"));
const AttributeWrap = styled_components_1.default.div(({ theme }) => theme.destinationAttributes.attributeWrap);
const AttributeItemWrap = styled_components_1.default.div(({ theme }) => theme.destinationAttributes.attributeItemWrap);
const AttributeIcon = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs({
    variant: `lg`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    verticalAlign: 'text-top',
    mr: 2,
}));
const AttributeDetailsList = styled_components_1.default.div(({ theme }) => theme.destinationAttributes.attributeDetailsList);
const AttributeDetailWrap = styled_components_1.default.div(({ theme }) => theme.destinationAttributes.attributeDetailWrap);
const DestinationAttributes = props => {
    const { attributes, hideOverallRating } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, attributes.map((attribute, i) => {
        return (react_1.default.createElement(AttributeWrap, { key: i },
            react_1.default.createElement(AttributeItemWrap, null,
                react_1.default.createElement("span", { className: "attributeName" },
                    react_1.default.createElement(AttributeIcon, { name: (0, DestinationAttributes_mappers_1.mapAttributeNameToIcon)(attribute.id) }),
                    attribute.name),
                hideOverallRating ? null : (react_1.default.createElement("div", { className: "attributeRatingWrap" },
                    react_1.default.createElement(DestinationRating_1.default, { rating: attribute.rating })))),
            react_1.default.createElement(AttributeDetailsList, null, (attribute.details || []).map((attributeDetail, idx) => {
                return (attributeDetail.rating > 0 && (react_1.default.createElement(AttributeDetailWrap, { key: attributeDetail.id || idx },
                    react_1.default.createElement("span", { className: "attributeDetailName" }, attributeDetail.name),
                    react_1.default.createElement("div", { className: "attributeRatingWrap" },
                        react_1.default.createElement(DestinationRating_1.default, { subRating: true, rating: attributeDetail.rating })))));
            }))));
    })));
};
exports.default = DestinationAttributes;
//# sourceMappingURL=DestinationAttributes.js.map